import { render } from "./ResetPassword.vue?vue&type=template&id=635374ba&scoped=true&ts=true"
import script from "./ResetPassword.vue?vue&type=script&lang=ts"
export * from "./ResetPassword.vue?vue&type=script&lang=ts"

import "./ResetPassword.vue?vue&type=style&index=0&id=635374ba&scoped=true&lang=css"

import exportComponent from "/home/webchat/thelounge-lfnet/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-635374ba"]])

export default __exports__